import { render, staticRenderFns } from "./ListingCertification.vue?vue&type=template&id=13b9c0ae&scoped=true&"
import script from "./ListingCertification.vue?vue&type=script&lang=js&"
export * from "./ListingCertification.vue?vue&type=script&lang=js&"
import style0 from "./ListingCertification.vue?vue&type=style&index=0&id=13b9c0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9c0ae",
  null
  
)

export default component.exports